// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3X98j","author":"Table_author__12SZW","authorImage":"Table_authorImage__1dMxs","unreadRow":"Table_unreadRow__3Zu-P"};